import { LoadActiveSearchType } from 'domain/usecases/active-search/load-active-search-type'
import { ActiveSearchRepository } from 'repository/repositories/active-search/active-search-repository'

export class RemoteLoadActiveSearchType implements LoadActiveSearchType {
  constructor(
    private readonly activeSearchRepository: ActiveSearchRepository
  ) {}

  load(
    params: LoadActiveSearchType.Params
  ): Promise<LoadActiveSearchType.Model> {
    return this.activeSearchRepository.loadActiveSearchType(params)
  }
}
